<template>
    <div>
        <modal-rating v-show="rating.showHideModalRating" v-bind:content="{storeModule: rating.storeModule, questionRate: rating.questionRate, section: rating.section}"></modal-rating>
        <div class="col-md-12">

            <!-- new modal -->
            <modal v-show="showModalAndTrack">
                <div slot="header" class="modal-header abtg__header-modal">
                    <h5 class="modal-title abtg__modal-title" id="exampleModalLabel">
                        ASTA</h5>

                    <div class="tools">
                        <div class="abtg__close-button"><a data-dismiss="modal" @click="closeModal()"><i
                                class="fas fa-times"></i></a></div>
                    </div>



                </div>
                <div slot="body">
                    <form @submit.prevent="onSubmit()">
                        <div class="modal-body">

                            <div class="row" :class="readModeCSS">

                                <div class="col" v-if="regionData.length > 0 ">
                                    <!-- EDIT MODE -->
                                    <div v-show="editMode">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select"
                                             style="margin-top:20px;">
                                            <label for="region_id"
                                                   class=" abtg__label-select">{{$t('auction.label_region')}}</label>
                                            <select class="mdl-textfield__input abtg__input abtg-select" tabIndex="-1"
                                                    id="region_id"
                                                    v-model="formData.regione"
                                                    @change="reloadCities(formData.regione)"
                                            >
                                                <option :value="region.regione" v-for="region in regionData">
                                                    {{CHANGE_REGION_NAME(region.regione)}}
                                                </option>
                                            </select>
                                            <p class="text-danger small" v-if="myErrors.region_id">
                                                {{myErrors.city_id[0]}}</p>
                                        </div>
                                    </div>

                                    <!-- READING MODE -->
                                    <div v-if="!editMode">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                            <label class="abtg__label-readmode">{{$t('auction.label_region')}}</label>
                                            <p class="abtg__text-readmode">{{this.CHANGE_REGION_NAME(regionCode)}}</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="col" v-if="regionData.length > 0 ">

                                    <!-- EDIT MODE -->
                                    <div v-show="editMode">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select"
                                             style="margin-top:20px;">
                                            <label for="city_id"
                                                   class=" abtg__label-select">{{$t('auction.label_city')}}</label>
                                            <select class="mdl-textfield__input abtg__input abtg-select" tabIndex="-1"
                                                    id="city_id"
                                                    v-model="formData.city_id"
                                                    v-show="editMode"
                                            >
                                                <option :value="city.id" v-for="city in cityData"
                                                >
                                                    {{city.comune}}
                                                </option>
                                            </select>

                                            <p class="text-danger small" v-if="myErrors.city_id">
                                                {{myErrors.city_id[0]}}</p>
                                        </div>
                                    </div>

                                    <!-- READING MODE -->
                                    <div v-if="!editMode">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                            <label class="abtg__label-readmode">{{$t('auction.label_city')}}</label>
                                            <p class="abtg__text-readmode">{{city}}</p>
                                        </div>
                                    </div>

                                </div>

                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <!-- EDIT MODE -->
                                        <div v-show="editMode">
                                            <input class="mdl-textfield__input abtg__input" type="text"
                                                   v-model="formData.indirizzo"
                                                   v-show="editMode"
                                            >

                                            <label class="mdl-textfield__label">{{$t('auction.label_address')}}</label>
                                            <p class="text-danger small" v-if="myErrors.address">
                                                {{myErrors.address[0]}}</p>
                                        </div>

                                        <!-- READING MODE -->
                                        <div v-if="!editMode">
                                            <label class="abtg__label-readmode">{{$t('auction.label_address')}}</label>
                                            <p class="abtg__text-readmode">{{formData.indirizzo}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> <!-- // row -->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>


                            <div class="row" :class="readModeCSS">
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.rge">
                                        <label class="mdl-textfield__label">{{$t('auction.label_rge')}}</label>
                                        <p class="text-danger small" v-if="myErrors.rge">{{myErrors.rge[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_rge')}}</label>
                                        <p class="abtg__text-readmode">{{this.DASH_IF_EMPTY(formData.rge)}}</p>
                                    </div>
                                </div>



                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.valore_ctu"
                                               v-money="money"
                                        >
                                        <label class="mdl-textfield__label">{{$t('auction.label_ctu')}}</label>
                                        <p class="text-danger small" v-if="myErrors.ctu">{{myErrors.ctu[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_ctu')}}</label>
                                        <p class="abtg__text-readmode">{{this.DASH_IF_EMPTY(formData.valore_ctu)}}</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.mq">
                                        <label class="mdl-textfield__label">{{$t('auction.label_mq')}}</label>
                                        <p class="text-danger small" v-if="myErrors.mq">{{myErrors.mq[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_mq')}}</label>
                                        <p class="abtg__text-readmode">{{formData.mq}}</p>
                                    </div>
                                </div>

                            </div> <!-- // row -->



                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>


                            <div class="row" :class="readModeCSS">
                                <div class="col">

                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.n_incanto">
                                        <label class="mdl-textfield__label">{{$t('auction.label_tender')}}</label>
                                        <p class="text-danger small" v-if="myErrors.tender">{{myErrors.tender[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_tender')}}</label>
                                        <p class="abtg__text-readmode">{{this.DASH_IF_EMPTY(formData.tender)}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.base_asta"
                                               v-money="money">
                                        <label class="mdl-textfield__label">{{$t('auction.label_auction_base')}}</label>
                                        <p class="text-danger small" v-if="myErrors.base_asta">
                                            {{myErrors.base_asta[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_auction_base')}}</label>
                                        <p class="abtg__text-readmode">{{formData.base_asta}}</p>
                                    </div>
                                </div>
                                <div class="col">

                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.offerta_minima"
                                               v-money="money"
                                        >
                                        <label class="mdl-textfield__label">{{$t('auction.label_minimum_offer')}}</label>
                                        <p class="text-danger small" v-if="myErrors.minimum_offer">
                                            {{myErrors.minimum_offer[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_minimum_offer')}}</label>
                                        <p class="abtg__text-readmode">{{formData.offerta_minima}}</p>
                                    </div>

                                </div>
                            </div> <!-- // row -->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>

                            <div class="row" :class="readModeCSS">
                                <div class="col">
                                    <!-- EDIT MODE-->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.rendita_catastale"
                                               v-money="money"
                                        >
                                        <label class="mdl-textfield__label">{{$t('auction.label_cadastral_income')}}</label>
                                        <p class="text-danger small" v-if="myErrors.rendita_catastale">
                                            {{myErrors.rendita_catastale[0]}}</p>
                                    </div>

                                    <!-- READING MODE-->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_cadastral_income')}}</label>
                                        <p class="abtg__text-readmode">{{formData.rendita_catastale}}</p>
                                    </div>
                                </div>

                                <div class="col">

                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">

                                        <date-picker v-model="formData.data_asta" lang="it"  placeholder="" format="DD/MM/YYYY"></date-picker>

                                        <label class="mdl-textfield__label" style="margin-top:-20px;">Data</label>


                                        <p class="text-danger small" v-if="myErrors.data_asta" style="margin-top:30px;">
                                            {{myErrors.data_asta[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_auction_date')}}</label>
                                        <p class="abtg__text-readmode">{{formData.data_asta}}</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <!-- EDIT MODE-->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.reg_urbanistica">
                                        <label class="mdl-textfield__label">{{$t('auction.label_city_planning')}}</label>
                                        <p class="text-danger small" v-if="myErrors.reg_urbanistica">
                                            {{myErrors.reg_urbanistica[0]}}</p>
                                    </div>

                                    <!-- READING MODE-->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_city_planning')}}</label>
                                        <p class="abtg__text-readmode">
                                            {{this.DASH_IF_EMPTY(formData.reg_urbanistica)}}</p>
                                    </div>
                                </div>
                            </div> <!-- // row -->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>

                            <div class="row" :class="readModeCSS">
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.n_creditori">
                                        <label class="mdl-textfield__label">{{$t('auction.label_creditors')}}</label>
                                        <p class="text-danger small" v-if="myErrors.n_creditori">
                                            {{myErrors.n_creditori[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_creditors')}}</label>
                                        <p class="abtg__text-readmode">{{formData.n_creditori}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.stato_occupazionale">
                                        <label class="mdl-textfield__label">{{$t('auction.label_occupancy_status')}}</label>
                                        <p class="text-danger small" v-if="myErrors.stato_occupazionale">
                                            {{myErrors.stato_occupazionale[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_occupancy_status')}}</label>
                                        <p class="abtg__text-readmode">
                                            {{this.DASH_IF_EMPTY(formData.stato_occupazionale)}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.valore_immobiliare_it"
                                               v-money="money"
                                        >
                                        <label class="mdl-textfield__label">{{$t('auction.label_building_value')}}</label>
                                        <p class="text-danger small" v-if="myErrors.valore_immobiliare_it">
                                            {{myErrors.valore_immobiliare_it[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_building_value')}}</label>
                                        <p class="abtg__text-readmode">{{formData.valore_immobiliare_it}}</p>
                                    </div>
                                </div>
                            </div> <!-- // row-->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>

                            <div class="row" :class="readModeCSS">
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.valore_borsino_immobiliare"
                                               v-money="money"
                                        >
                                        <label class="mdl-textfield__label">{{$t('auction.label_borsino_value')}}</label>
                                        <p class="text-danger small" v-if="myErrors.valore_borsino_immobiliare">
                                            {{myErrors.valore_borsino_immobiliare[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_borsino_value')}}</label>
                                        <p class="abtg__text-readmode">{{formData.valore_borsino_immobiliare}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.street_price"
                                               v-money="money">
                                        <label class="mdl-textfield__label">{{$t('auction.label_street_price')}}</label>
                                        <p class="text-danger small" v-if="myErrors.street_price">
                                            {{myErrors.street_price[0]}}</p>
                                    </div>

                                    <!-- READING MODE-->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_street_price')}}</label>
                                        <p class="abtg__text-readmode">{{formData.street_price}}</p>
                                    </div>
                                </div>
                                <div class="col">

                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.riferimenti_custode">
                                        <label class="mdl-textfield__label">{{$t('auction.label_guardian')}}</label>
                                        <p class="text-danger small" v-if="myErrors.riferimenti_custode">
                                            {{myErrors.riferimenti_custode[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_guardian')}}</label>
                                        <p class="abtg__text-readmode">
                                            {{this.DASH_IF_EMPTY(formData.riferimenti_custode)}}</p>

                                    </div>
                                </div>
                            </div> <!-- // row -->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>


                            <div class="row" :class="readModeCSS">
                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.agenzia_1"
                                               v-money="money">
                                        <label class="mdl-textfield__label">{{$t('auction.label_agency_1')}}</label>
                                        <p class="text-danger small" v-if="myErrors.agency_1">
                                            {{myErrors.agenzia_1[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_agency_1')}}</label>
                                        <p class="abtg__text-readmode">{{formData.agenzia_1}}</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.agenzia_2"
                                               v-money="money">
                                        <label class="mdl-textfield__label">{{$t('auction.label_agency_2')}}</label>
                                        <p class="text-danger small" v-if="myErrors.agency_2">
                                            {{myErrors.agenzia_2[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_agency_2')}}</label>
                                        <p class="abtg__text-readmode">{{formData.agenzia_2}}</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <!-- EDIT MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="formData.agenzia_3"
                                               v-money="money">
                                        <label class="mdl-textfield__label">{{$t('auction.label_agency_3')}}</label>
                                        <p class="text-danger small" v-if="myErrors.agency_3">
                                            {{myErrors.agenzia_3[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_agency_3')}}</label>
                                        <p class="abtg__text-readmode">{{formData.agenzia_3}}</p>
                                    </div>
                                </div>
                            </div> <!-- // row -->


                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>

                            <div class="row" :class="readModeCSS">

                                <div class="col-md-12">
                                    <!-- EDIT MODE -->
                                    <div style="max-width: 100%!important;"
                                         class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-show="editMode">
                                        <textarea class="mdl-textfield__input abtg__input" type="text"
                                                  v-model="formData.note"></textarea>
                                        <label class="mdl-textfield__label">{{$t('auction.label_note')}}</label>
                                        <p class="text-danger small" v-if="myErrors.note">{{myErrors.note[0]}}</p>
                                    </div>

                                    <!-- READING MODE -->
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         v-if="!editMode">
                                        <label class="abtg__label-readmode">{{$t('auction.label_note')}}</label>
                                        <p class="abtg__text-readmode" style="font-weight:normal">{{formData.note}}</p>
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="formData.link">

                                    <p>Link dell'annuncio: <a :href="formData.link" target="_blank">Portale Vendite Pubbliche</a></p>

                                </div>
                                <div class="col-md-4">


                                </div>
                            </div> <!-- // row -->

                            <div class="row" v-show="!editMode"  style="margin-bottom:20px;">
                                <div class="col">
                                    <hr class="abtg__hr">
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">

                                    <label class="mdl-textfield__label" style="margin-left:15px;margin-top: -30px;">{{$t('auction.label_excerpt')}}</label>
                                    <div style="margin-top:35px;">
                                    <div class="custom-radios">
                                            <div>
                                                <input type="checkbox" id="color-5" name="color"
                                                       v-model="formData.stralciabile"
                                                       :value="1"
                                                >
                                                <label for="color-5">
                                                    <span><i class="fas fa-check"></i></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">

                                    <label class="mdl-textfield__label"
                                           style="margin-top: -30px;margin-left: 15px;">{{$t('auction.label_choose_color')}}
                                    </label>
                                    <div style=" float:left;margin-left:90px;margin-top:-5px;">
                                        <popover module="auction" content="legend" position="top"></popover>
                                    </div>


                                    <div class="clearfix"></div>
                                    <div class="custom-radios">

                                        <div>
                                            <input type="radio" id="color-1" name="color"
                                                   v-model="formData.color"
                                                   :value="1"
                                            >
                                            <label for="color-1">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-2" name="color"
                                                   v-model="formData.color"
                                                   :value="2">
                                            <label for="color-2">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-3" name="color" v-model="formData.color"
                                                   :value="3">
                                            <label for="color-3">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-4" name="color" v-model="formData.color"
                                                   :value="4">
                                            <label for="color-4">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                    <p class="text-danger small" v-if="myErrors.color">{{myErrors.color[0]}}</p>

                                </div>
                            </div> <!-- // row -->


                        </div>
                        <div slot="footer">
                            <!-- EDIT MODE -->


                            <button type="submit"
                                    class="margin-right-10 btn-success float-right abtg__btn-star"
                                    v-show="editMode"
                            >

                                SALVA
                            </button>

                            <!-- READING MODE -->
                            <button type="button"
                                    class="margin-right-10 btn-success float-right abtg__btn-star"
                                    v-if="!editMode"
                                    @click="onOffEditMode"
                            >

                                MODIFICA
                            </button>

                            <transition name="bounce">
                                <div v-if="saveOk">
                                    <div class="float-right abtg__saveMode">Salvato!</div>
                                </div>
                            </transition>


                        </div>
                    </form>
                </div>


            </modal>
            <!-- // end modal -->


        </div>
    </div>
</template>

<script>
    import Modal from '../../components/commons/modal';
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import Popover from '../commons/popover';
    import modalRating from '../commons/rating';
    import DatePicker from 'vue2-datepicker';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });
    export default {
        mixins: [mixin],
        components: {Money, Modal, Popover, modalRating, DatePicker},
        data: function () {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '€ ',
                    suffix: '',
                    precision: 0,
                    masked: false
                }
            }
        },


        computed: {
            ...mapFields(['readModeCSS', 'editMode', 'showAuctionCard', 'cityData', 'regionData', 'myErrors', 'formData', 'saveOk', 'showModal', 'city', 'regionCode', 'rating']),

            showModalAndTrack: function()
            {
                this.showModal === true ? this.track(): null;
                return this.showModal;
            }
        },
        created: function () {
            this.$store.dispatch('auction/formDataSpace');
        },
        methods: {
            track: function () {
                this.$store.dispatch('track/create', 'Inserimento Asta', {root: true});
            },
            onSubmit: function () {
                this.$store.dispatch('auction/sendData')
            },
            reloadCities: function (regionCode) {

                this.$store.dispatch('auction/cityList', regionCode);
            },

            closeModal() {
                this.$store.dispatch('auction/closeModal');
            },

            onOffEditMode: function () {
                this.$store.dispatch('auction/onOffEditMode', true);
            }

        }
    }
</script>
